import { render, staticRenderFns } from "./features_navigation.vue?vue&type=template&id=86318046&scoped=true&"
import script from "./features_navigation.vue?vue&type=script&lang=ts&"
export * from "./features_navigation.vue?vue&type=script&lang=ts&"
import style0 from "./features_navigation.vue?vue&type=style&index=0&id=86318046&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86318046",
  null
  
)

export default component.exports